import { RootState } from "store";

export const getActiveKitchen = (state: RootState) =>
  state.kitchen.activeKitchen;

export const getKitchenOrderFilters = (state: RootState) =>
  state.kitchen.filters;

export const getKitchenSettings = (state: RootState) => state.kitchen.settings;
